// Centralized copy. All visible strings live here so swapping languages and
// rewriting copy stays painless during prototyping.

export const messages = {
  th: {
    'nav.home': 'หน้าแรก',
    'nav.register': 'ลงทะเบียน',
    'nav.features': 'แนะนำเกม',
    'nav.story': 'เนื้อเรื่อง',
    'nav.staff': 'พนักงาน',
    'nav.campaign': 'แคมเปญ',
    'nav.lang': 'TH',

    'cta.register': 'ลงทะเบียน',
    'cta.topUp': 'เติมเงิน',
    'cta.influencer': 'แคมเปญอินฟลู',
    'cta.join': 'เข้าร่วม',
    'cta.readMore': 'อ่านเพิ่มเติม',
    'cta.back': 'ย้อนกลับ',
    'cta.next': 'ถัดไป',

    'hero.title': 'I Love Cooking',
    'hero.subtitle': 'ดาวน์โหลดเลย!',
    'hero.videoCaption': 'ดูตัวอย่างเกม',
    'hero.comingSoon': 'เร็วๆ นี้',
    'hero.underConstruction': 'อยู่ระหว่างการพัฒนา',
    'hero.supportLabel': 'ติดต่อสอบถาม',

    'register.title': 'ลงทะเบียนล่วงหน้า',
    'register.subtitle': 'ลงทะเบียนล่วงหน้าวันนี้ รับรางวัลไปพร้อมกัน',
    'register.closed': 'ปิดรับลงทะเบียนแล้ว',
    'register.participantsLabel': 'จำนวนผู้เล่นที่\nลงทะเบียนล่วงหน้า',
    'register.reward.0': '300 เครื่องดื่ม',
    'register.reward.1': '300,000 โกลด์',
    'register.reward.2': '300 รูบี้',
    'register.reward.3': '10 ตั๋วกาชา',
    'register.reward.4': 'โอลีฟ (เกรด S)',

    'register.modal.title': 'ลงทะเบียน',
    'register.modal.storeSubtitle': '1. ลงทะเบียนผ่าน Store',
    'register.modal.emailSubtitle': '2. ลงทะเบียนผ่านอีเมล',
    'register.modal.emailPlaceholder': 'อีเมล',
    'register.modal.submit': 'ลงทะเบียน',
    'register.modal.submitting': 'กำลังลงทะเบียน...',
    'register.modal.errorDuplicate': 'อีเมลนี้ลงทะเบียนไปแล้ว',
    'register.modal.errorInvalid': 'รูปแบบอีเมลไม่ถูกต้อง',
    'register.modal.errorGeneric': 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง',
    'register.modal.errorClosed': 'ปิดรับลงทะเบียนแล้ว',
    'register.modal.close': 'ปิด',
    'register.modal.successLine1': 'ขอบคุณที่ลงทะเบียนล่วงหน้า',
    'register.modal.successLine2': 'อย่าลืมลงทะเบียน',
    'register.modal.successLine3Store': 'บน Store',
    'register.modal.successLine3Suffix': ' ด้วยนะคะ',
    'register.modal.successBadge': 'สำเร็จ',

    'story.title': 'เนื้อเรื่อง',
    'story.subtitle': 'ร้านอาหาร และอาณาจักรเหมียว',
    'story.body.0':
      'เจ้าหญิงเพียงหนึ่งเดียวแห่งอาณาจักรแมว ถูกอัญเชิญมายังโลกมนุษย์\nโดยความผิดพลาดของพิธีกรรมบางอย่าง ท่ามกลางความสับสนและแปลกแยก เธอได้รับความช่วยเหลือจากคุณ ผู้บังเอิญผ่านมา และยื่นมือเข้ามาช่วยเหลือ ในช่วงเวลาที่เธอไม่เหลือใคร',
    'story.body.1':
      'เพื่อเป็นการตอบแทนบุญคุณนั้น  เจ้าหญิงจึงส่ง “นักวางแผน” ผู้เก่งกาจที่สุดของอาณาจักร\nลงมายังโลกมนุษย์ ..แมวพูดได้ผู้เย็นชาและเปี่ยมด้วยสติปัญญา\nในตอนแรก เขามองร้านอาหารเล็ก ๆ แห่งนี้ด้วยสายตาเฉยเมย',
    'story.body.2':
      'ราวกับว่าทุกอย่างเป็นเพียงเรื่องไร้สาระ ที่ไม่คู่ควรกับเวลา และความสามารถของตน\nแต่เมื่อวันเวลาผ่านไป.. เมื่อได้เห็นร้านที่เคยซบเซา\nค่อย ๆ เปลี่ยนแปลง พนักงานที่เคยไร้ทิศทางเริ่มมีเป้าหมาย',
    'story.body.3':
      'รอยยิ้มเล็ก ๆ ค่อย ๆ กลับคืนมา บางสิ่งในตัวเขาเริ่มสั่นไหว\nจากเพียงหน้าที่… กลายเป็นความผูกพัน  จากผู้เฝ้ามอง… กลายเป็นครอบครัว โดยไม่รู้ตัว  แมวผู้เย็นชาตนนั้น กำลังเปลี่ยนแปลงไปทีละน้อย พร้อมกับร้านแห่งนี้..',

    'features.title': 'แนะนำเกม',
    'features.subtitle': 'TEXT TEXT TEXT',

    'staff.title': 'พนักงาน',
    'staff.titleAccent': 'สุดยูนีค',
    'staff.subtitle': 'มากกว่า 40+ คน พร้อมเข้าร้าน!',
    'staff.name.0': 'โอลีฟ',
    'staff.name.1': 'อลิเซีย',
    'staff.name.2': 'ชูครีม',
    'staff.name.3': 'เชฟเจด',
    'staff.name.4': 'เซซามิ',
    'staff.name.5': 'ชาร์ลอตต์',
    'staff.name.6': 'เอลิเซ',
    'staff.name.7': 'โมโมะ',
    'staff.name.8': 'เนโกะ',
    'staff.name.9': 'ฟารินา',
    'staff.name.10': 'ฟลาน',
    'staff.name.11': 'พนักงานอีกเพียบ!',
    'staff.bubble.0': 'โปรดวางใจ\nให้ฉันช่วยดูแลนะคะ~',
    'staff.bubble.1': 'จะเสิร์ฟทุกจาน\nอย่างตั้งใจค่ะ',
    'staff.bubble.2': 'ขนมหวานหวาน\nหนูถนัดมาก!',
    'staff.bubble.3': 'อาหารมื้อนี้\nให้ผมดูแลนะครับ',
    'staff.bubble.4': 'รสชาติแปลกใหม่\nคือที่สุด!',
    'staff.bubble.5': 'รับประกัน\nอร่อยเลิศระดับโลก~',
    'staff.bubble.6': 'คุณหนูอย่างฉัน\nจะพิสูจน์ให้ท่านพ่อเห็นเอง!',
    'staff.bubble.7': 'โอม..\nจงอร่อยขึ้น เพี้ยง~',
    'staff.bubble.8': 'ผจญภัยสนุกๆ\nผ่านรสชาติหลากหลาย',
    'staff.bubble.9': 'ร้านนี้ต้องตกแต่ง\nสักหน่อยแล้ว..',
    'staff.bubble.10': 'ผมค้นหาตัวตน\nผ่านอาหารและผู้คน',
    'staff.bubble.11': '#ทีมตัวตึง\n#หลังก็ตึง',

    'campaign.title':
      '🍳 I Love Cooking\nCreator Program\nเปิดรับสมัครแล้ว!\n\nชอบเล่นเกม? ชอบทำคอนเทนต์?\nหรืออยากเริ่มต้นเป็น Creator\nกับเกมน่ารัก ๆ สักเกม?',
    'campaign.titleDesktop':
      '🍳 I Love Cooking\nCreator Program\nเปิดรับสมัครแล้ว!\n\nชอบเล่นเกม? ชอบทำคอนเทนต์?\nหรืออยากเริ่มต้นเป็น Creator\nกับเกมน่ารัก ๆ สักเกม?\n\nเรากำลังมองหา Creator, Influencer,\nStreamer และผู้เล่นที่อยากสร้าง\nคอนเทนต์สนุก ๆ ไปด้วยกัน 🎮',
    'campaign.heading': 'ครีเอเตอร์',
    'campaign.subtitle': 'ครีเอเตอร์คนดังประจำเกม',
    'campaign.detail':
      'เรากำลังมองหา Creator, Influencer,\nStreamer และผู้เล่นที่อยากสร้าง\nคอนเทนต์สนุก ๆ ไปด้วยกัน\n\nไม่ต้องเป็น Creator ใหญ่\nขอแค่มีไอเดียและความตั้งใจ 💖',
    'campaign.detailDesktop':
      'ไม่จำเป็นต้องเป็น Creator ใหญ่\nไม่จำเป็นต้องมียอดวิวเยอะ\nขอแค่มีไอเดียและความตั้งใจ 💖\n\nCreator ที่เข้าร่วมจะได้รับ\n🎁 ไอเทมและของรางวัลพิเศษในเกม\n📣 โอกาสโปรโมตผ่านช่องทาง Official\n🎬 ร่วมกิจกรรมและแคมเปญพิเศษ\n🍽️ ข่าวสารและอัปเดตก่อนใคร',
    'campaign.readMore': 'อ่านเพิ่มเติม',
    'campaign.modal.body':
      '🍳 I Love Cooking Creator Program เปิดรับสมัครแล้ว!\n\nชอบเล่นเกม? ชอบทำคอนเทนต์? หรืออยากเริ่มต้นเป็น Creator กับเกมน่ารัก ๆ สักเกม?\n\nI Love Cooking กำลังมองหา Creator, Influencer, Streamer และผู้เล่นที่อยากสร้างคอนเทนต์สนุก ๆ ไปกับเรา\n\nไม่จำเป็นต้องเป็น Creator ใหญ่\nไม่จำเป็นต้องมียอดวิวเยอะ\nขอแค่คุณมีไอเดีย มีความตั้งใจ และอยากร่วมเสิร์ฟความสนุกให้กับผู้เล่น I Love Cooking 💖\n\nCreator ที่เข้าร่วมจะมีโอกาสได้รับ\n🎁 ไอเทมและของรางวัลพิเศษในเกม\n📣 โอกาสได้รับการโปรโมตผ่านช่องทาง Official\n🎬 โอกาสร่วมกิจกรรมหรือแคมเปญพิเศษ\n🍽️ ข่าวสารและอัปเดตจากทีมงานก่อนใคร\n\nเราเปิดรับ Creator หลายสไตล์ เช่น\n✨ สายคลิปสั้น\n✨ สายรีวิวเกม\n✨ สายไลฟ์สตรีม\n✨ สายไลฟ์สไตล์ / อาหาร\n✨ ผู้เล่นที่อยากลองทำคอนเทนต์เกี่ยวกับเกม\n\nมาร่วมเป็นส่วนหนึ่งของครอบครัว I Love Cooking Creator ไปด้วยกันนะ 🍳💕',
    'campaign.modal.applyLabel': 'สมัครได้ที่นี่',
    'campaign.modal.applyUrl': 'https://forms.gle/DoZeuLvrjsg34wQPA',

    'footer.privacy': 'privacy policy',
    'footer.terms': 'terms of service',
    'footer.copyright': '© 2025 G-MILLION CO., LTD. All Rights Reserved',

    'legal.privacy.title': 'นโยบายความเป็นส่วนตัว',
    'legal.tos.title': 'ข้อกำหนดในการให้บริการ',
    'legal.backHome': 'กลับสู่หน้าแรก',

    'notFound.title': 'ไม่พบหน้าที่คุณค้นหา',
    'notFound.redirecting': 'กำลังพากลับสู่หน้าแรก...',
  },
  en: {
    'nav.home': 'Home',
    'nav.register': 'Register',
    'nav.features': 'Features',
    'nav.story': 'Story',
    'nav.staff': 'Staff',
    'nav.campaign': 'Campaign',
    'nav.lang': 'EN',

    'cta.register': 'Register',
    'cta.topUp': 'Top Up',
    'cta.influencer': 'Influencer',
    'cta.join': 'Join',
    'cta.readMore': 'Read more',
    'cta.back': 'Back',
    'cta.next': 'Next',

    'hero.title': 'I Love Cooking',
    'hero.subtitle': 'Download now!',
    'hero.videoCaption': 'Watch trailer',
    'hero.comingSoon': 'Coming Soon',
    'hero.underConstruction': 'Under Construction',
    'hero.supportLabel': 'Contact support',

    'register.title': 'Pre-Registration',
    'register.subtitle': 'Pre-register today and claim rewards together',
    'register.closed': 'Registration closed',
    'register.participantsLabel': 'Players who have\npre-registered',
    'register.reward.0': '300 Drinks',
    'register.reward.1': '300,000 Gold',
    'register.reward.2': '300 Rubies',
    'register.reward.3': '10 Tickets',
    'register.reward.4': 'Olive (Grade S)',

    'register.modal.title': 'Pre-Register',
    'register.modal.storeSubtitle': '1. Register through the Store',
    'register.modal.emailSubtitle': '2.Register with email',
    'register.modal.emailPlaceholder': 'Email',
    'register.modal.submit': 'Register',
    'register.modal.submitting': 'Submitting...',
    'register.modal.errorDuplicate': 'This email is already registered.',
    'register.modal.errorInvalid': 'Please enter a valid email address.',
    'register.modal.errorGeneric': 'Something went wrong. Please try again.',
    'register.modal.errorClosed': 'Registration has closed.',
    'register.modal.close': 'Close',
    'register.modal.successLine1': 'Thank you for pre-registering',
    'register.modal.successLine2': "Don't forget to register",
    'register.modal.successLine3Store': 'on the Store',
    'register.modal.successLine3Suffix': ' too',
    'register.modal.successBadge': 'Done',

    'story.title': 'Story',
    'story.subtitle': 'The Restaurant and the Cat Kingdom',
    'story.body.0':
      'The only princess of the Cat Kingdom was summoned to the human world\nby the mistake of a certain ritual. Confused and far from home, she was helped by you, a passerby who reached out when she had no one left.',
    'story.body.1':
      'To repay that kindness, the princess sent the kingdom’s most talented “Strategist”\ndown to the human world: a cold, intelligent talking cat.\nAt first, he looked at this little restaurant with indifferent eyes,',
    'story.body.2':
      'as if everything here were pointless, unworthy of his time or ability.\nBut as the days passed... as he watched the once-quiet shop\nslowly begin to change, and the aimless staff start finding goals of their own,',
    'story.body.3':
      'small smiles quietly returned, and something inside him began to stir.\nFrom mere duty... it became a bond. From an observer... he became family without realizing it. That cold cat is slowly changing, little by little, together with this restaurant...',

    'features.title': 'Features',
    'features.subtitle': 'TEXT TEXT TEXT',

    'staff.title': 'Unique',
    'staff.titleAccent': 'Staff',
    'staff.subtitle': 'More than 40+ staff!',
    'staff.name.0': 'Olive',
    'staff.name.1': 'Alicia',
    'staff.name.2': 'Choux Cream',
    'staff.name.3': 'Chef Jade',
    'staff.name.4': 'Sesami',
    'staff.name.5': 'Charlotte',
    'staff.name.6': 'Elise',
    'staff.name.7': 'Momo',
    'staff.name.8': 'Neko',
    'staff.name.9': 'Farina',
    'staff.name.10': 'Flan',
    'staff.name.11': 'Many more staff!',
    'staff.bubble.0': 'Rest assured,\nI will take care of you~',
    'staff.bubble.1': 'I will serve every dish\nwith care.',
    'staff.bubble.2': 'Sweet desserts\nare my specialty!',
    'staff.bubble.3': 'Let me take care\nof this meal for you.',
    'staff.bubble.4': 'Fresh new flavors\nare the best!',
    'staff.bubble.5': 'Guaranteed\nworld-class deliciousness~',
    'staff.bubble.6': 'I will prove it\nto Father myself!',
    'staff.bubble.7': 'Ommm...\nmake it tastier, poof~',
    'staff.bubble.8': 'Adventure through\nall kinds of flavors',
    'staff.bubble.9': 'This place needs\na little decorating...',
    'staff.bubble.10': 'I am finding myself\nthrough food and people',
    'staff.bubble.11': '#TopSquad\n#BackPainSquad',

    'campaign.title':
      '🍳 I Love Cooking\nCreator Program\nis now open!\n\nLove gaming? Love making content?\nOr want to start out as a Creator\nwith a cute little game?',
    'campaign.titleDesktop':
      "🍳 I Love Cooking\nCreator Program\nis now open!\n\nLove gaming? Love making content?\nOr want to start out as a Creator\nwith a cute little game?\n\nWe're looking for Creators, Influencers,\nStreamers and players who want to make\nfun content together with us. 🎮",
    'campaign.heading': 'Creators',
    'campaign.subtitle': 'Featured creators',
    'campaign.detail':
      "We're looking for Creators, Influencers,\nStreamers and players who want to make\nfun content together with us.\n\nNo need to be a big Creator —\njust bring your ideas and passion 💖",
    'campaign.detailDesktop':
      "No need to be a big Creator,\nno need for huge view counts —\njust bring your ideas and passion 💖\n\nCreators who join will get\n🎁 Exclusive in-game rewards and items\n📣 Features on our official channels\n🎬 Special campaigns and creator events\n🍽️ Early access to news and updates",
    'campaign.readMore': 'Read more',
    'campaign.modal.body':
      "🍳✨ The I Love Cooking Creator Program is Now Open!\n\nLove gaming? Love creating content? We're looking for creators, streamers, influencers, and passionate players to join us and share their I Love Cooking experience with the world! 💛\n\nWhether you're an experienced content creator or just getting started, we'd love to hear from you.\n\n🎁 Creator Benefits\n✨ Exclusive in-game rewards and items\n📣 Opportunities to be featured on our official channels\n🎬 Access to special campaigns and creator events\n🍽️ Early access to news, updates, and upcoming content\n\nWe're looking for creators of all kinds:\n🎥 Short-form video creators\n🎮 Gaming content creators\n📺 Streamers\n🍰 Food & lifestyle creators\n🌱 Players who enjoy sharing their gaming adventures\n\nLet's create something amazing together! 🍳💕",
    'campaign.modal.applyLabel': 'Apply here',
    'campaign.modal.applyUrl': 'https://forms.gle/DoZeuLvrjsg34wQPA',

    'footer.privacy': 'Privacy policy',
    'footer.terms': 'Terms of service',
    'footer.copyright': '© 2025 G-MILLION CO., LTD. All Rights Reserved',

    'legal.privacy.title': 'Privacy Policy',
    'legal.tos.title': 'Terms of Service',
    'legal.backHome': 'Back to homepage',

    'notFound.title': 'Page not found',
    'notFound.redirecting': 'Redirecting you to the homepage…',
  },
} as const;

export type Lang = keyof typeof messages;
export type MessageKey = keyof (typeof messages)['th'];
